import { Sidebar, SidebarBody, SidebarItem, SidebarLabel, SidebarSection } from "@components/Catalyst/sidebar";
import { useAuth } from "@contexts/AuthContext";

import React from "react";
import { FaUser } from "react-icons/fa";
import toast from "react-hot-toast";
import MenuTopLevel from "./MenuTopLevel";
import { saLinks } from "../data";

const GacSASidebar = () => {
  const { gacUser, logout, ShowLoginModal } = useAuth();

  return (
    <Sidebar className="dark bg-black">
      <SidebarBody>
        <SidebarSection>
          {!gacUser && (
            <>
              <SidebarItem onClick={() => ShowLoginModal("login")}>
                <SidebarLabel>Sign In</SidebarLabel>
              </SidebarItem>

              <SidebarItem onClick={() => ShowLoginModal("forgot-password")}>
                <SidebarLabel> Forgot Password</SidebarLabel>
              </SidebarItem>

              <SidebarItem onClick={() => ShowLoginModal("new-account")}>
                <SidebarLabel>Create Account </SidebarLabel>
              </SidebarItem>
            </>
          )}
          {gacUser && (
            <>
              <SidebarItem href="/studio-assistant/profile">
                <SidebarLabel>
                  <div className="flex items-center">
                    <FaUser size={16} />

                    {gacUser.email}
                  </div>
                </SidebarLabel>
              </SidebarItem>

              {saLinks.map((childItem) => (
                <MenuTopLevel item={childItem} key={childItem.label} />
              ))}

              <SidebarItem
                onClick={() => {
                  toast.promise(logout(), {
                    loading: "Signing out...",
                    success: "You have signed out.",
                    error: "An error occurred while signing out.",
                  });
                }}
              >
                <SidebarLabel>Sign Out</SidebarLabel>
              </SidebarItem>
            </>
          )}
        </SidebarSection>
      </SidebarBody>
    </Sidebar>
  );
};

export default GacSASidebar;
